import { Typography } from '@/components/ui/typography'
import { Loader2 } from 'lucide-react'
import type { ReactNode } from 'react'

type PosCartTotalRowProps = {
  label: ReactNode
  value: ReactNode
  /** The row the eye lands on: the total, or what a change does to it. */
  strong?: boolean
  /** The amount is being priced again: a spinner stands in for it, as the cart's own totals do while it saves. */
  pending?: boolean
}

/** One label-and-amount line of an order change's summary. */
export function PosCartTotalRow({
  label,
  value,
  strong = false,
  pending = false,
}: PosCartTotalRowProps) {
  const variant = strong ? 'labelStrong' : 'label'
  const tone = strong ? 'default' : 'muted'

  return (
    <div className="flex min-w-0 items-center justify-between gap-2">
      <Typography variant={variant} tone={tone} className="truncate">
        {label}
      </Typography>
      {pending ? (
        <Loader2 className="size-3 shrink-0 animate-spin text-muted-foreground" />
      ) : (
        <Typography variant={variant} tone={tone} className="shrink-0 tabular-nums">
          {value}
        </Typography>
      )}
    </div>
  )
}
